import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from "./routers"
import store from '../store'
Vue.use(VueRouter)
// import config from '@/config'


const router = new VueRouter({
  routes
})
router.beforeEach((to,from,next)=>{

  store.dispatch('getSystemInfo').then(res=>{
    console.log('SystemInfo',res)
    next()
  },err=>{
    console.log('err1',err)
    next()
  }).catch(err=>{
    console.log('err2',err)
    next()
  })
  // if(to.meta.title){
  //   document.title = to.meta.title;
  // }else {
  //   document.title = config.title;
  // }
})
export default router
